<script lang="ts">
    import { _ } from "svelte-i18n"
    import Cart from "./Cart.svelte"
    import { fly } from "svelte/transition"
    import { cartOverlay, location } from "../../store"
    import { clickOutside } from "../../utils"
    import { mdiClose } from "@mdi/js"
    import Icon from "../widgets/Icon.svelte"
</script>

<div
    class="cartoverlay"
    transition:fly="{{ x: 1000 }}"
    use:clickOutside="{(target) => {
        if (!document.getElementById('cartIconLink')?.contains(target) && !$location.path.startsWith('/checkout'))
            $cartOverlay = false
    }}"
>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a
        class="cart_closer"
        href=""
        on:click|preventDefault="{() => {
            $cartOverlay = false
        }}"
    >
        <Icon path="{mdiClose}" size="24px" />
    </a>
    <Cart checkoutButton="{!$location.path?.startsWith('/checkout')}" />
</div>

<style lang="less">
    @import "../../css/variables.less";
    .cartoverlay :global {
        position: fixed;
        bottom: 0;
        left: initial;
        right: 0;
        width: 100vw;
        top: 0px;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 2000;
        background: var(--surface);
        color: var(--on-surface);

        @media @desktop {
            width: 50vw;
            border-left: 1px solid var(--border-color-default);
            overflow-y: auto;
        }
        @media @desktop_large {
            width: 30vw;
        }
        .cart_closer {
            background: var(--background);
            color: var(--on-background);
            .flex();
            align-items: center;
            border-bottom: 1px solid var(--border-color-default);
            padding: 3px 20px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 65px;
        }
        .cart {
            padding: 25px;
            .product {
                .image {
                    height: 50vw;
                    @media @mobile {
                        width: 200px !important;
                        height: 150px !important;
                        margin-right: 15px;
                    }
                }
            }
        }
    }
</style>
